import {atom} from 'recoil';

import {TypeAccountRoles} from '../../shared/types/user-account.types';

export interface IUserInfo {
  id: number;
  userLogin: string;
  isActive: boolean;
  roles?: TypeAccountRoles[];
  email: string;
  phoneNumber: string;
  firstName: string;
  patronymic: string;
  lastName: string;
  needToChangePasswd: boolean;
  userPrincipalId: number;
  companyId: string;
  uid: string;
}

export const authState = atom<{
  user: IUserInfo | null;
  isLoggedIn: boolean;
  isFirstLogin: boolean;
}>({
  key: 'authState',
  default: {
    user: null,
    isLoggedIn: false,
    isFirstLogin: true,
  },
});
